import { urlKeys } from "../../api/url";
import { toast } from 'react-toastify';

export const checkUserAccessLevel = (role_id) => {
  switch (role_id) {
    case "1":
      return ["AHJPage"];
    case "2":
      return ['AddSite', 'AddUser', 'DeleteSite', 'DeleteUser'];
    case "5":
      return ['AHJPage'];
    case "4":
      return ['AddRelease', 'AddSite', 'AddUser', 'Approve', 'Reject', 'DeleteRelease', 'DeleteSite', 'DeleteUser', 'AddContract'];
    case "3":
    default:
      return ['AddContract', 'AddFirmware', 'AddRelease', 'AddSite', 'AddUser', 'Approve', 'Reject', 'DeleteUser', 'DeleteFirmware', 'DeleteRelease', 'DeleteSite', 'DeleteUser', 'AddContract', "DeleteContract"];
  }
}

export const getUserRole = (role_id) => {
  switch (role_id) {
    case "1":
      return 'GA';
    case "2":
      return 'RM';
    case "5":
      return 'TS';
    case "4":
      return 'FM';
    case "3":
    default:
      return 'Viewer'
  }
}

export const getAPIUrl = (apiKey) => {
  return `${urlKeys[apiKey]}`;
}

const err = "error";
const no_err = "valid"
const userName_customerName_Checker = (value) => {
  const minUsernameLength = 3;
  const maxUsernameLength = 30;
  const username_regex = /^[A-Za-z\s}]+$/;
  return value && username_regex.test(value) &&
    value.length >= minUsernameLength &&
    value.length <= maxUsernameLength
    ? no_err
    : err;
}

const fileName_Checker = (value) => {
  const minFilenameLength = 4;
  const maxFilenameLength = 30;
  const filename_regex = /^[A-Za-z0-9_-]*$/;
  return value &&
    filename_regex.test(value) &&
    value.length >= minFilenameLength &&
    value.length <= maxFilenameLength
    ? no_err
    : err;
}

const firmwareVersion_Checker = (value) => {
  const minVersionLength = 2;
  const version_regex = /^[A-Za-z0-9_-]*\.?[A-Za-z0-9_-]*$/;
  return value && version_regex.test(value) && value.length >= minVersionLength
    ? no_err
    : err;
}

const customerEmailid_Checker = (value) => {
  const customer_id_regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{3,}$/;
  return value && customer_id_regex.test(value) ? no_err : err;
}

const siteName_Checker = (value) => {
  const siteName_regex = /^[A-Za-z0-9\s_-]+$/;
  return value && siteName_regex.test(value) ? no_err : err;
}

const siteAddress_Checker = (value) => {
  const siteAddress_regex = /^[#.0-9a-zA-Z\s/,-]+$/;
  return value && siteAddress_regex.test(value) ? no_err : err;
}

const siteState_siteCountry_Checker = (value) => {
  const area_regex = /^[A-Za-z\s]+$/;
  return value && area_regex.test(value) ? no_err : err;
}

const siteCity_Checker = (value) => {
  const city_regex = /^[a-zA-Z\s]*$/;
  return city_regex.test(value) ? no_err : err;
}

const isValidDomain = (domain) => {
  const otisDomain_regex = /^[A-Za-z0-9._%]*@(otis|otiselevator|otisjp)*\.(net|com|biz)$/;
  return otisDomain_regex.test(domain) ? no_err : err;
}

const isTextFile = (value) => {
  const acceptedTypes = ['txt'];
  const nameExtension = value.split('.').pop();
  return (value && acceptedTypes.includes(nameExtension)) ? no_err : err;
}

const isPdfFile = (value) => {
  const acceptedTypes = ['pdf'];
  const nameExtension = value.split('.').pop();
  return (value && acceptedTypes.includes(nameExtension)) ? no_err : err;
}

// Extract component code from component type string
// Component code format: numeric or alphanumeric code (e.g., "78609" from component type)
export const extractComponentCode = (componentTypeLabel) => {
  if (!componentTypeLabel) return "";
  const codeMatch = componentTypeLabel.match(/\((\d{4,})\)/);
  return codeMatch ? codeMatch[1] : "";
};

export const isProductionPrefixRequired = (componentCode) => {
  const allowedComponentCodes = ["37023"];
  return allowedComponentCodes.some(code => componentCode === code);
}

// Validate firmware version with all checks combined
// Includes: length, format, component code presence, and production_ prefix for Compass Fixture
export const validateFirmwareVersionWithComponentCode = (versionValue, code, componentName) => {
  if (!versionValue || !code || !componentName) return "valid";


  // 1. Check minimum length
  const minVersionLength = 2;
  if (versionValue.length < minVersionLength) {
    return "error";
  }
  let version_regex;
    if(isProductionPrefixRequired(code)) {
  version_regex = /^production_[A-Z0-9]*[_-][A-Z][0-9A-Za-z-_]*$/;
  if(!version_regex.test(versionValue)) {
    return "error";
  }
    } else {
      version_regex = /^[A-Z0-9]*[-_][A-Z][0-9A-Za-z-_]*$/;
      if (!version_regex.test(versionValue)) {
        return "error";
      }
    }

  // 4. Validate that code is present
  // This is required for all components
  if (!versionValue.includes(code)) {
    return "error";
  }

  return "valid";
};

// Validate file name contains firmware version and has correct extension
export const validateFileNameWithFirmwareVersion = (fileName, firmwareVersion) => {
  if (!fileName) return "valid";

  const filename_regex = /^[A-Za-z0-9_-]+(?:\.(?:tar|zip))?$/i;
  if (!filename_regex.test(fileName)) {
    return "error";
  }

  return "valid";
};

export const ValidateInputField = (name, value, type, firmwareVersion) => {
  switch (name) {
    case "username":
    case "customer_name":
      return userName_customerName_Checker(value);
    case "userid":
    case "field_team_email_id":
      return isValidDomain(value);
    case "customer_email_id":
      return customerEmailid_Checker(value);
    case "site_name":
      return siteName_Checker(value);
    case "site_address":
      return siteAddress_Checker(value);
    case "site_country":
    case "site_state":
      return siteState_siteCountry_Checker(value);
    case "site_city":
      return siteCity_Checker(value);
    case "site":
    case "componenttype_id":
    case "contracts":
      return value.length !== 0 ? no_err : err;
    case "firmware_version":
      return firmwareVersion_Checker(value);
    case "File":
      return validateFileNameWithFirmwareVersion(value, firmwareVersion);
    case "release_notes":
      return isTextFile(value);
    case "reject_reason":
      return value && value.length > 4 ? no_err : err;
    case "contract_number":
      return fileName_Checker(value);
    case "network_diagram":
      return isPdfFile(value);
    default:
      return no_err;
  }
}

export const notify = (type, message) => {
  if (typeof type == "string") {
    if (type.length > 0) {
      if (type === "submission") {
        return toast.error("Error Adding The Record");
      } else if (type === "fetching") {
        return toast.error("Error Fetching The Data");
      } else if (type === "updating") {
        return toast.error("Error Updating The Record");
      } else if (type === "delete") {
        return toast.error("Error Deleting The Record");
      } else if (type === "approve/reject") {
        return toast.error("Error Approving/Rejecting The Release");
      } else if (type === "downloading") {
        return toast.error("Error Downloading The Release Notes");
      } else if(type === "noText") {
          return toast.error("No Content in Release Notes");
      } else if (type === "alert") {
        return toast.error(message || "Please select/enter a valid domain (e.g. example.com)");
      } else {
        return toast.error("Error! Please try again later");
      }
    }
    else {
      return type;
    }
  } else {
    return type;
  }

}

export const information = (information) => {
  if (!information || !information?.building_name || !information?.component_type) {
    return information?.building_name ?? "Unknown Building";
  }
  return toast.success(`Release Report of Site: ${information?.building_name} and Component Type: ${information?.component_type}`)
}

const GRID_CELL_CLASSNAME = "ag-cell";

function getAllFocusableElementsOf(el) {
  return Array.from(
    el.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    ),
  ).filter((focusableEl) => {
    return focusableEl.tabIndex !== -1;
  });
}

function getEventPath(event) {
  const path = [];
  let currentTarget = event.target;

  while (currentTarget) {
    path.push(currentTarget);
    currentTarget = currentTarget.parentElement;
  }

  return path;
}

const calculateisTabForward = (key, shiftKey) => {
  const isTabForward = key === "Tab" && shiftKey === false;
  return isTabForward;
}

const calculateisTabBackward = (key, shiftKey) => {
  const isTabBackward = key === "Tab" && shiftKey === true;
  return isTabBackward;
}

const calculateisEntered = (key, shiftKey) => {
  const isEntered = key === "Enter" && shiftKey === false;
  return isEntered;
}

export const suppressKeyboardEvent = ({ event }) => {
  const path = getEventPath(event);
  const { key, shiftKey } = event;

  let suppressEvent = false;

  // Handle cell children tabbing
  if (calculateisTabForward(key, shiftKey) || calculateisTabBackward(key, shiftKey) || calculateisEntered(key, shiftKey)) {
    const eGridCell = path.find((el) => {
      if (el.classList === undefined) return false;
      return el.classList.contains(GRID_CELL_CLASSNAME);
    });

    if (!eGridCell) {
      return suppressEvent;
    }

    const focusableChildrenElements = getAllFocusableElementsOf(eGridCell);
    const lastCellChildEl =
      focusableChildrenElements[focusableChildrenElements.length - 1];
    const firstCellChildEl = focusableChildrenElements[0];

    const calculateIsLastChild = () => {
      const isLastChildFocused =
        lastCellChildEl && document.activeElement === lastCellChildEl;
      if (!isLastChildFocused || calculateisEntered(key, shiftKey)) {
        suppressEvent = true
        return suppressEvent;
      }
    }

    const calculateTabForwardEnteredFocused = () => {
      return ((calculateisTabForward(key, shiftKey) || calculateisEntered(key, shiftKey)) && focusableChildrenElements.length) > 0
    }

    const calculateTabBackwardEnteredFocused = () => {
      return ((calculateisTabBackward(key, shiftKey) || calculateisEntered(key, shiftKey)) && focusableChildrenElements.length) > 0
    }

    // Suppress keyboard event if tabbing forward within the cell and the current focused element is not the last child
    if (calculateTabForwardEnteredFocused()) {
      calculateIsLastChild();
    }
    // Suppress keyboard event if tabbing backwards within the cell, and the current focused element is not the first child
    else if (calculateTabBackwardEnteredFocused()) {
      const cellHasFocusedChildren =
        eGridCell.contains(document.activeElement) &&
        eGridCell !== document.activeElement;

      // Manually set focus to the last child element if cell doesn't have focused children
      if (!cellHasFocusedChildren) {
        lastCellChildEl.focus();
        // Cancel keyboard press, so that it doesn't focus on the last child and then pass through the keyboard press to
        // move to the 2nd last child element
        event.preventDefault();
      }

      const calculateFocusedEntered = () => !isFirstChildFocused || calculateisEntered(key, shiftKey)

      const isFirstChildFocused =
        firstCellChildEl && document.activeElement === firstCellChildEl;
      if (calculateFocusedEntered()) {
        suppressEvent = true;
      }
    }
  }

  return suppressEvent;
}


export const RESTRICTED_DOMAINS = [
  "gmail.com",
  "yahoo.com",
];